// Screen `blueprint-configure` (owner feedback F7) — owner: blueprints.
import { createFileRoute } from '@tanstack/react-router';
import { ConfigurePage } from '../../../../../features/blueprints/ConfigurePage';

export const Route = createFileRoute('/_settings/settings/blueprints/$key/configure')({
  component: BlueprintConfigureRoute,
});

function BlueprintConfigureRoute() {
  const { key } = Route.useParams();
  return <ConfigurePage key={key} blueprintKey={key} />;
}
